






































































































































































































































































import {
  BlogManagerArticleService as blogApi,
  BlogManagerTagService as tagApi,
} from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import QEditor from "@/components/common/qEditor.vue";
import QLanguageBox from "@/components/common/qLanguageBox.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSetting from "@/components/common/qReleaseSetting.vue";
import qUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import { SETTING, STATUS } from "@/model/releaseSetting";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

@Component({
  name: "BlogEditComponent",
  components: {
    QEditor,
    QReleaseSetting,
    QLanguageTab,
    QLanguageBox,
    QErrors,
    vSelect,
    qUploadSingleImage,
  },
})
export default class BlogEditComponent extends Vue {
  public title = "ブログの新規作成";
  public articleId = null;
  public errors = {};
  public form: any = {
    title: "",
    title_en: null,
    title_cn: null,
    image: {
      id: "",
      name: "",
    },
    context: "",
    context_en: null,
    context_cn: null,
    tag_ids: [],
    open_status: STATUS.EDIT,
    release_setting: null,
    post_date: null,
  };
  public originalForm;
  public files: any = [];
  public fileUploadStatus = "";
  public languages = [LANG.EN, LANG.CN];

  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };
  public contextLang = LANG.JA;
  public tagLang = LANG.JA;
  public selectedTags = [];
  public tags = [];
  public recentTags = [];
  public uploading = false;
  public postDate = null;

  get langList() {
    return [...[LANG.JA], ...this.languages];
  }

  public uploadStatus(flag) {
    this.uploading = flag;
  }
  public async mounted() {
    this.tag();
    this.getRecentTags();
    this.articleId = this.$router.currentRoute.params?.id;

    if (this.articleId) {
      await this.getDetail();
      this.title = `${this.form.title} の編集`;
    }

    if (!this.form.title_cn && !this.form.context_cn) {
      const index = this.languages.indexOf(LANG.CN);
      this.languages.splice(index, 1);
    }
    this.originalForm = { ...this.form };
  }

  public async tag() {
    const result = await tagApi.adminTag({
      count: null,
      keyword: null,
    });
    this.tags = result.data.tags;
  }

  public getRecentTags() {
    const recent_tags = localStorage.getItem("recent_tags");
    this.recentTags = JSON.parse(recent_tags);
  }

  public async getDetail() {
    const result = await blogApi.adminArticleShow({
      id: this.articleId,
    });

    this.form = result.data.article;
    this.form.tag_ids = this.form.tags.map((item) => {
      return item.id;
    });
    this.selectedTags = this.form.tags;

    if (
      this.form.open_status === STATUS.RELEASE &&
      moment(this.form.post_date).isBefore(moment())
    ) {
      this.form.release_setting = SETTING.NOW;
      this.form.post_date = null;
    }

    if (this.form.post_date) {
      this.form.post_date = moment(this.form.post_date).format(
        "YYYY-MM-DD HH:mm",
      );
    }
    this.postDate = this.form.post_date;
  }

  public async submit() {
    let parameters: any = {};
    let result;
    try {
      parameters = {
        title: this.form.title,
        title_en: this.languages.includes("en") ? this.form.title_en : null,
        title_cn: this.languages.includes("cn") ? this.form.title_cn : null,
        image_id: this.form.image ? this.form.image.id : null,
        context: this.form.context,
        context_en: this.languages.includes("en") ? this.form.context_en : null,
        context_cn: this.languages.includes("cn") ? this.form.context_cn : null,
        tag_ids: this.form.tag_ids.filter((tag) => tag),
        open_status: this.form.open_status,
        release_setting: this.form.release_setting,
        post_date: this.form.post_date,
      };

      result = this.articleId
        ? await blogApi.adminArticleEdit({
          ...parameters,
          ...{ id: this.articleId },
        })
        : await blogApi.adminArticleCreate(parameters);

      QNotify.success({
        text: this.articleId
          ? this.$t("common.message.updated")
          : this.$t("common.message.created"),
      });
      this.$router.back();
    } catch (error: any) {
      result = error.body;
      QNotify.error({
        text: result.message,
      });
      this.errors = result.errors;
      if ("context" in this.errors) {
        this.contextLang = LANG.JA;
      } else if ("context_en" in this.errors) {
        this.contextLang = LANG.EN;
      } else if ("context_cn" in this.errors) {
        this.contextLang = LANG.CN;
      }
    }
  }

  public confirmDelete() {
    this.$modal.showDelete({
      text: `${this.$t("common.message.delete_confirm")}`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await blogApi.adminArticleDelete({
            id: this.articleId,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.$router.back();
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public cancel() {
    // check modifier form.
    const diff = compareWithKeys(this.form, this.originalForm, [
      "title",
      "title_en",
      "title_cn",
      "image_id",
      "context",
      "context_en",
      "context_cn",
      "tag_ids",
      "open_status",
      "post_date",
      "release_setting",
    ]);

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.$router.back();
        },
      });
    } else {
      this.$router.back();
    }
  }

  public async preview() {
    const form = { ...this.form };
    form.post_date = this.postDate
      ? moment(this.postDate).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    form.updated_at = form.updated_at
      ? moment(form.updated_at).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    localStorage.setItem("article", JSON.stringify(form));
    const previewRoute = this.$router.resolve({ name: "admin.blog.preview" });
    window.open(previewRoute.href, "_blank");
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }

  public async changeTags() {
    let found = this.selectedTags.find((item) => item.id === undefined);
    if (found !== undefined) {
      if (typeof found !== "object") {
        found = { name: found };
      }
      try {
        const result = await tagApi.adminTagCreate({
          name: found.name,
        });

        this.selectedTags.splice(
          this.selectedTags.length - 1,
          1,
          result.data.tag,
        );
      } catch (error) {
        const resultBody = error.body;
        QNotify.error({
          text: resultBody.message,
        });
        this.errors = resultBody.errors;
      }
    }
    this.form.tag_ids = this.selectedTags.map((item) => {
      return item.id;
    });
    this.setRecentTags();
  }

  public setRecentTags() {
    if (this.selectedTags.length === 0) {
      return;
    }
    let storageTags = [];
    if (this.recentTags !== null) {
      storageTags = [...this.recentTags];
    }
    this.selectedTags.find(function(item) {
      const result = storageTags.findIndex((value) => value.id === item.id);
      if (result > -1) {
        storageTags.splice(result, 1);
      }
      storageTags.unshift(item);
    });
    if (storageTags.length > 10) {
      storageTags.splice(10);
    }
    localStorage.setItem("recent_tags", JSON.stringify(storageTags));
  }

  public getStatus(item): string {
    const result = this.selectedTags.findIndex((value) => value.id === item.id);
    if (result > -1) {
      return "on";
    }
    return "";
  }

  public getStyle(item): string {
    const result = this.selectedTags.findIndex((value) => value.id === item.id);
    if (result > -1) {
      return `pointer-events: none; ${
        item.name.toString().length >= 100
          ? "height: auto; padding-top: .5em; padding-bottom: .5em"
          : ""
      }`;
    }
    if (item.name.toString().length >= 100) {
      return "height: auto; word-break: break-all; padding-top: .5em; padding-bottom: .5em";
    }
    return "";
  }
  public changeRecentTags(item) {
    this.selectedTags.push(item);
    this.changeTags();
  }

  public pushError(message, item) {
    this.errors = {
      ...this.errors,
      ...{ [item]: message },
    };
  }
  public changeFile(file) {
    this.form.image = {
      ...this.form.image,
      ...{
        id: file ? file.id : null,
        name: file ? file.filePath : null,
      },
    };
  }

  public openFile() {
    (this.$refs.uploadSingleImage as qUploadSingleImage).open();
  }

  public deleteSelectTag(tag) {
    if (tag.name.toString().length >= 255) { this.changeInput("name"); }

    if (tag.id) {
      this.selectedTags = this.selectedTags.filter(
        (item) => item.id !== tag.id,
      );
      this.form.tag_ids = this.selectedTags.map((item) => {
        return item.id;
      });
      return;
    }

    this.selectedTags = this.selectedTags.filter(
      (item) => item.name !== tag.name && !!item.id,
    );
    this.form.tag_ids = this.selectedTags.map((item) => {
      return item.id;
    });
  }
}
